// CacheKey 9f98be448a0c69037ddc651822c0742c
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  pl: {
    date: {
      abbr_month_names: [
        "stycz",
        "luty",
        "mar",
        "kwiec",
        "maj",
        "czerw",
        "lip",
        "sierp",
        "wrzes",
        "pazdz",
        "listop",
        "grudz"
      ],
      month_names: [
        null,
        "styczeń",
        "luty",
        "marsz",
        "kwiecień",
        "może",
        "czerwiec",
        "lipiec",
        "sierpień",
        "wrzesień",
        "październik",
        "listopad",
        "grudzień"
      ],
      order: [
        "day",
        "month",
        "year"
      ],
      day_names: [
        "niedziela",
        "poniedziałek",
        "wtorek",
        "środa",
        "czwartek",
        "piątek",
        "sobota"
      ],
      formats: {
        default: "%d/%m/%Y",
        long: "%d %B %Y",
        short: "%d %b"
      }
    },
    time: {
      pm: "pm",
      am: "am"
    },
    time_zones: {
      est: "czas wschodni",
      edt: "czas wschodni",
      cst: "czas centralny",
      cdt: "czas centralny",
      mst: "czas górski",
      mdt: "czas górski",
      pst: "czas pacyficzny",
      pdt: "czas pacyficzny",
      hst: "czas hawajsko-aleucki",
      hdt: "czas hawajsko-aleucki",
      akst: "czas alaskański",
      akdt: "czas alaskański"
    }
  }
}

